import { Choices } from './choice';
import { initialSignature, Signature } from './signature';

export enum DEFICIENCY_SELECTION {
    NO_SELECTION = 'NO_SELECTION',
    NO_DEFICIENCIES = 'NO_DEFICIENCIES',
    SLIGHT_DEFICIENCIES = 'SLIGHT_DEFICIENCIES',
    SERIOUS_DEFICIENCIES = 'SERIOUS_DEFICIENCIES',
}

export enum MEASUREMENT_SELECTION {
    NO_SELECTION = 'NO_SELECTION',
    INITIAL_MEASUREMENT = 'INITIAL_MEASUREMENT',
    REPEAT_MEASUREMENT = 'REPEAT_MEASUREMENT',
}

export type SystemCondition = Readonly<{
    employeeSignature: Signature;
    customerSignature: Signature;
    heading: string;
    noDeficienciesLabel: string;
    slightDeficienciesLabel: string;
    seriousDeficienciesLabel: string;
    deficienciesSelection: DEFICIENCY_SELECTION;
    deficienciesXmlId: string;
    imagingRemark: string;
    remarksLabel: string;
    remarksXmlId: string;
    remarksValue: string;
    initialMeasurementLabel?: string; // only for Safety protocols '834'
    repeatMeasurementLabel?: string; // only for Safety protocols '834'
    measurementSelection?: MEASUREMENT_SELECTION; // only for Safety protocols '834'
    measurementXmlId?: string; // only for Safety protocols '834'
    choices?: Choices; // only available in cosima
    choicesFunctionalElementXmlId?: string; // only available in cosima
}>;

export const initialSystemConditionState: SystemCondition = {
    deficienciesSelection: DEFICIENCY_SELECTION.NO_SELECTION,
    deficienciesXmlId: '',
    customerSignature: initialSignature,
    employeeSignature: initialSignature,
    heading: '',
    imagingRemark: '',
    noDeficienciesLabel: '',
    slightDeficienciesLabel: '',
    seriousDeficienciesLabel: '',
    remarksLabel: '',
    remarksXmlId: '',
    remarksValue: '',
    initialMeasurementLabel: '',
    repeatMeasurementLabel: '',
    measurementSelection: MEASUREMENT_SELECTION.NO_SELECTION,
    measurementXmlId: '',
};
